var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightBlueSmallArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 12.5C7 12.2631 7.08727 12.0262 7.27429 11.8392L14.8423 4.27118C15.2039 3.90961 15.8023 3.90961 16.1639 4.27118C16.5255 4.63275 16.5255 5.23121 16.1639 5.59278L9.25669 12.5L16.1639 19.4072C16.5255 19.7688 16.5255 20.3673 16.1639 20.7288C15.8023 21.0904 15.2039 21.0904 14.8423 20.7288L7.27429 13.1608C7.08727 12.9738 7 12.7369 7 12.5Z",
    fill: "#4786FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBlueSmallArrowLeft);
export default __webpack_public_path__ + "static/media/light-blue-small-arrow-left.6daee3a3562396d11185057cbabf0a37.svg";
export { ForwardRef as ReactComponent };